import * as React from 'react'
import { ReactElement } from 'react'
import useEntity from '../../hooks/useEntity'
import Loading from '../../components/Loading'
import LegalPersonForm from '../../components/Form/Party/LegalPersonForm'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { CreateDto } from '../../config/filePartyConfig'
import { AddPartyProps, PartyStatus } from '../../components/Form/Party/PartyForm'
import { LegalPersonMutationDto } from '../../config/partyConfig'
import useAxios from '../../hooks/useAxios'
import { getPartyOverviewUrl } from './AddNaturalPerson'

export default function AddLegalPerson(): ReactElement {
    const axios = useAxios()
    const history = useHistory()
    const { fileId } = useParams<{ fileId?: string }>()
    // Populate the payment term fields.
    const [scaffold] = useEntity<LegalPersonMutationDto>(
        () => ({ url: '/party/legal/scaffold', method: 'POST' }),
        false,
    )
    const location = useLocation()

    if (!scaffold.loaded) {
        return <Loading />
    }

    return (
        <LegalPersonForm
            formikProps={{
                initialValues: {
                    ...scaffold.data,
                    status: PartyStatus.Active,
                    externals: {},
                } as LegalPersonMutationDto,
            }}
            onSubmit={(party: LegalPersonMutationDto) =>
                axios.post<string>('/party/legal', {
                    ...party,
                    pivot: fileId ? ({ fileId, ...((location.state as AddPartyProps) || {}) } as CreateDto) : undefined,
                })
            }
            goBack={() => history.replace(getPartyOverviewUrl(fileId))}
        />
    )
}
